module.exports = __webpack_public_path__ + "static/optional-0715f4cc8c073a5dfa8ec2bab0289bd3.png";